// https://stackoverflow.com/questions/7738117/html-text-overflow-ellipsis-detection
export const isOverflowActive = (element) => {
    const tolerance = 2; // In px. Depends on the font you are using
    return element.offsetWidth + tolerance < element.scrollWidth;
};
//# sourceMappingURL=isOverflowActive.js.map